/** @jsxImportSource @emotion/react */

import React from 'react';

import NotificationBadge, {
  INotificationBadge,
} from '../../../../../components/notificationBadge';

export interface IFiveColumnBadgeCell extends INotificationBadge {
  type: 'badge';
}

interface IFiveColumnBadeCellProps {
  data: IFiveColumnBadgeCell;
}

const FiveColumnBadgeCell = ({ data }: IFiveColumnBadeCellProps) => {
  return <NotificationBadge {...data} />;
};

export default FiveColumnBadgeCell;
